/*
 * File: main.js
 * Created Date: 2022.8.28
 * Author : TaekHwan.Park (taekhwan.park@gmail.com)
 *
 * Copyright (c) 2022 Fyltech PTE., LTD., Inc
 */

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import './styles/tailwind_3.1.8.css'        // download from https://live.arkscan.io/
import './styles/dark.css' 

import VueAxios from 'vue-axios'
import vClickOutside from 'click-outside-vue3'

import ApiService from './services/api.service'
import FdsApiService from './services/fds-api.service'

const app = createApp(App)

// Composition API: Dependency Injection
// 24.09.03. showing용 데이터. 2023년 이후에 입력된 더즌 데이터 + 2022년도 결산 데어터를 사용함.
// 2022-8-15일 이후로 더즌에서 데이터가 전송되었기 때문에 2022년 데이터는 결산 데이터 추정치로 사용함. backend(app.js, socket)에서 2023-01-01일 이후의 데이터만 집계해서 전송함.
const totalShowingTxCountFor2022 = 1651873
const globalMonthShowingData = [
    { ctx_datetime: '2022-06', cnt: '126730' },
    { ctx_datetime: '2022-07', cnt: '188254' },
    { ctx_datetime: '2022-08', cnt: '246974' },
    { ctx_datetime: '2022-09', cnt: '227660' },
    { ctx_datetime: '2022-10', cnt: '278626' },
    { ctx_datetime: '2022-11', cnt: '304058' },
    { ctx_datetime: '2022-12', cnt: '279571' },
]
app.provide('totalShowingTxCountFor2022', totalShowingTxCountFor2022)
app.provide('globalMonthShowingData', globalMonthShowingData)

app.use(VueAxios, ApiService, FdsApiService)
app.use(router);
app.use(store)
app.use(vClickOutside)
app.mount('#app')